export default __webpack_public_path__ + "static/media/smart_logo.8b3b3227.svg";